<template>
  <router-link :to="this.destObj"> 
    {{ prefix }}{{ displayId }}
  </router-link>
</template>

<script>
export default {
  name: "Uuid",
  props: {
    id: {
      type: String,
      default: ''
    },
    routerKey: String,
    routerName: String,
    isShortened: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    // Display shortened id as per request. Logic modifiable upon further request.
    displayId: function() {
      return this.isShortened ? this.id.split('-')[0] : this.id
    },
    // Prepare the destination object for router link
    destObj: function() {
      return {
        name: this.routerName,
        params: { [this.routerKey]: this.id }
      }
    }
  }
}
</script>
